import { render, staticRenderFns } from "./DaliyWinLostChart.vue?vue&type=template&id=23040273&scoped=true"
import script from "./DaliyWinLostChart.vue?vue&type=script&lang=js"
export * from "./DaliyWinLostChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23040273",
  null
  
)

export default component.exports